import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { withTranslation } from "react-i18next";

const DateField = ({
  label = "",
  formik = null,
  name,
  minDate,
  maxDate,
  isDisable = false,
  t,
  ...props
}) => {
  const { touched, errors, setFieldValue, setFieldTouched, values } =
    formik || {};

  const isError = !!get(touched, name, "") && !!get(errors, name, "");
  const minDateProp = minDate ? { minDate: minDate } : {};
  const maxDateProp = maxDate ? { maxDate: maxDate } : {};

  return (
    <div className="mb-1">
      <DatePicker
        label={label}
        className="w-100"
        size="small"
        slotProps={{
          textField: {
            size: "small",
            error: isError,
            onBlur: () => setFieldTouched(name, true),
          },
          popper: {
            popperOptions: {
              strategy: "fixed",
            },
            onBlur: () => setFieldTouched(name, true),
          },
        }}
        value={get(values, name, "") || null}
        onChange={(value) => {
          if (value?.isValid()) {
            setFieldValue(name, value);
          } else {
            setFieldValue(name, "");
          }
        }}
        disabled={isDisable}
        {...minDateProp}
        {...maxDateProp}
        {...props}
      />

      <Typography
        variant="subtitle2"
        className={` ${
          isError ? "visible" : "invisible"
        } input-field-error-message`}
        color="error"
      >
        {t(get(errors, name, ""))}
      </Typography>
    </div>
  );
};

DateField.propTypes = {
  formik: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isDisable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(DateField);
